/**
 * Enum of all stored proedures.
 */
export enum StoredProcedure {
  DeleteOpenSlots = 'deleteOpenSlots',
  GetMonthlyUsage = 'getMonthlyUsage',
  GetStatistics = 'getStatistics'
}
